import script from "./Complaints.vue?vue&type=script&setup=true&lang=js"
export * from "./Complaints.vue?vue&type=script&setup=true&lang=js"

import "./Complaints.vue?vue&type=style&index=0&id=6152027c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6152027c"]])

export default __exports__